import { Box, Typography } from '@mui/material';
import { getSegmentationJobDetails_getSEOSegmentationJobDetails_seoSegmentationJob_jobPreferences_TutoringJobPreferences as tutoringJobPreferences } from '@/__generated__/getSegmentationJobDetails';

interface TutoringJobPreferencesProps {
  jobPreferences: tutoringJobPreferences;
}

const TutoringJobPreferences = ({ jobPreferences }: TutoringJobPreferencesProps) => {
  return (
    jobPreferences.subjectAreas && (
      <Box mt={2}>
        <Typography variant="body2">
          Subject Areas: {jobPreferences.subjectAreas.join(', ')}
        </Typography>
      </Box>
    )
  );
};

export default TutoringJobPreferences;
